import React from 'react';
import SearchableSelect from './SearchableSelect';

/**
 * The VAT rate picker — one owner for all six invoicing surfaces.
 *
 * Finance operators know the RATE, not the code. The picker displays
 * "151 (9.00%)" but only searched vat_code / description, and refused to fire
 * below 2 characters, so typing `9`, `9%` or `0%` returned nothing while the
 * rate sat right there (vat-rate-percentage-search, 2026-08-19).
 *
 * Owned here so the three rules stay in one place:
 *   - percentage-aware search (backend: VATRatePercentageSearchFilter)
 *   - one character is enough (single-digit rates are the common case)
 *   - opening the picker lists the entity's rates instead of an empty box
 *
 * Callers still own value / onChange / params (entity scoping) and the
 * per-screen percentage cache.
 */
const VatRateSelect = (props) => (
  <SearchableSelect
    fetchUrl="/api/invoicing/vat-rates/"
    displayFn={(vat) => `${vat.vat_code} (${vat.rate_percentage}%)`}
    placeholder="Search VAT — 9, 9% or code"
    minSearchLength={1}
    listOnOpen
    variant="table"
    {...props}
  />
);

export default VatRateSelect;
